import api from "./api";

interface TrainingTask {
  id: number;
  name: string | null;
  model_type: string | null;
  epochs: number;
  learning_rate: string;
  batch_size: number;
  status: string; // pending, training, completed, failed, saved
  progress: number;
  result_loss: string | null;
  result_accuracy: string | null;
  training_time: string | null;
  sample_count: number | null;
  x_file_name: string | null;
  y_file_name: string | null;
  user_id: number | null;
  created_at: string;
  updated_at: string;
}

async function listTasks(): Promise<TrainingTask[]> {
  return api.get<TrainingTask[]>("/training/tasks");
}

async function getTask(taskId: number): Promise<TrainingTask> {
  return api.get<TrainingTask>(`/training/tasks/${taskId}`);
}

async function createTask(
  xFile: File,
  yFile: File,
  modelType: string,
  epochs = 10,
  learningRate = "0.001",
  batchSize = 32
): Promise<{ id: number; status: string }> {
  const formData = new FormData();
  formData.append("x_file", xFile);
  formData.append("y_file", yFile);
  formData.append("model_type", modelType);
  formData.append("epochs", String(epochs));
  formData.append("learning_rate", learningRate);
  formData.append("batch_size", String(batchSize));
  return api.upload<{ id: number; status: string }>("/training/tasks", formData);
}

async function startTask(taskId: number): Promise<{ message: string; id: number }> {
  return api.post(`/training/tasks/${taskId}/start`);
}

async function saveModel(taskId: number): Promise<{ message: string; id: number }> {
  return api.post(`/training/tasks/${taskId}/save-model`);
}

export type { TrainingTask };
export { listTasks, getTask, createTask, startTask, saveModel };
